import api from '../../../api/consultations/_consultation-group-sections'

const state = () => ({
    consultation_group_sections: [],
    active_group_sections: [],
    evolution_id_initiale: 0,
    current_consultation_evolution: 0,
    default_consultation_sections: []
})

// getters
const getters = {
    consultation_group_sections: (state) => {
        return state.consultation_group_sections
    },

    active_group_sections: (state) => {
        return state.active_group_sections
    },

    evolution_id_initiale: (state) => {
        return state.evolution_id_initiale
    },

    default_consultation_sections: (state) => {
        return state.default_consultation_sections
    },

    current_consultation_evolution: (state) => {
        return state.current_consultation_evolution
    },
}

// mutations
const mutations = {
    SET_CONSULTATION_GROUP_SECTIONS(state, liste) {
        state.consultation_group_sections = liste
    },

    SET_ACTIVE_GROUP_SECTIONS(state, liste) {
        state.active_group_sections = liste
    },

    SET_EVOLUTION_ID_INITIALE(state, liste) {
        state.evolution_id_initiale = liste
    },

    SET_DEFAULT_CONSULTATION_SECTIONS(state, liste) {
        state.default_consultation_sections = liste
    },

    SET_CURRENT_CONSULTATION_EVOLUTION(state, liste) {
        state.current_consultation_evolution = liste
    },
}

// actions
const actions = {
    getListeConsultationGroupSection({commit}, consultation_id){
        return new Promise((resolve,reject) => {
            api.getListeConsultationGroupSection(consultation_id).then(
                response => {
                    commit('SET_CONSULTATION_GROUP_SECTIONS', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeOfActiveGroupSections({commit}, data){
        return new Promise((resolve,reject) => {
            api.getListeOfActiveGroupSections(data).then(
                response => {
                    commit('SET_ACTIVE_GROUP_SECTIONS', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getEvolutionIDInitiale({commit}, data){
        return new Promise((resolve,reject) => {
            api.getEvolutionIDInitiale(data).then(
                response => {
                    commit('SET_EVOLUTION_ID_INITIALE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getDefaultConsultationSections({commit}, is_default){
        return new Promise((resolve,reject) => {
            api.getDefaultConsultationSections(is_default).then(
                response => {
                    commit('SET_DEFAULT_CONSULTATION_SECTIONS', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveConsultationEvolution({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConsultationEvolution(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveConsultationSection({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConsultationSection(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getCurrentConsultationEvolution({commit}, consultation_id){
        return new Promise((resolve,reject) => {
            api.getCurrentConsultationEvolution(consultation_id).then(
                response => {
                    commit('SET_CURRENT_CONSULTATION_EVOLUTION', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveConsultationSectionOrder({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConsultationSectionOrder(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
    
}

export default {
    state,
    getters,
    mutations,
    actions
}